export default "__VITE_ASSET__DypwlQRK__"